import React from "react";
import "./footer.css";
import gpt3Logo from "../../assets/logo.svg";
import ScrollToTop from "react-scroll-to-top";
import { SiAutoprefixer } from "react-icons/si";
import { motion, useInView } from "framer-motion";

const Footer = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: false });

  React.useEffect(() => {
    console.log("isInView", isInView);
  }, [isInView]);

  return (
    <>
      <ScrollToTop
        style={{ background: "#ff4820" }}
        smooth
        top={1000}
        component={
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            whileHover={{ y: -10 }}
            transition={{
              type: "spring",
              duration: 0.4,
            }}
            className="gpt3__footer-scrollUp"
          >
            <SiAutoprefixer color="white" size={25} />
            <p>TOP</p>
          </motion.div>
        }
      />

      <div className="gpt3__footer_topGradient" />
      <div className="gpt3__footer section__padding">
        <div className="gpt3__footer-heading">
          <motion.h1
            ref={ref}
            className="gradient__text"
            style={{
              opacity: isInView ? 1 : 0,
              transition: "all .6s ease .1s",
              scale: isInView ? 1 : 2,
              y: isInView ? 0 : 200,
            }}
          >
            Do you want to step in to the future before others
          </motion.h1>
        </div>
        <div className="gpt3__footer-btn">
          <p>Request Early Access</p>
        </div>
        <div className="gpt3__footer-links">
          <div className="gpt3__footer-links_logo">
            <img src={gpt3Logo} alt="logo" />
            <p>Crechterwoord K12 182 DK Alknjkcb, All Rights Reserved</p>
          </div>
          <div className="gpt3__footer-links_div">
            <h4>Links</h4>
            <p>Overone</p>
            <p>Social Media</p>
            <p>Counters</p>
            <p>Contact</p>
          </div>
          <div className="gpt3__footer-links_div">
            <h4>Company</h4>
            <p>Terms & Conditions</p>
            <p>privacy Policy</p>
            <p>Contact</p>
          </div>
          <div className="gpt3__footer-links_div">
            <h4>Get in touch</h4>
            <p>Crechterwoord K12 182 DK Alknjkcb</p>
            <p>085-132567</p>
            <p>info@payme.net</p>
          </div>
        </div>
        <div className="gpt3__footer-copyright">
          <p>&#169; 2023 GPT-3. All rights reserved</p>
          <br />
          <p>
            Created by{" "}
            <a href="https://github.com/jagdishlove">@jagdish.funn@gmail.com</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
